export type MarkerData = {
  name: string;
  latitude: number;
  longitude: number;
};

export type WaypointInfo = {
  id: number;
  name: string;
  address: string;
  coordinates: {
    latitude: number;
    longitude: number;
  };
};

export type Leg = {
  distance: number;
  duration: number;
  waypoint_from: WaypointInfo;
  waypoint_to: WaypointInfo;
};

/**
 * Route data structure for map directions and polyline.
 * @property routes - Array of route objects
 * @property clientLocations - Array of client location objects
 */
export type RouteData = {
  polyline: string;
  leg_overviews: Leg[];
  status: string;
};

/**
 * Marker type for map elements.
 * @property type - 'client' or 'origin'
 * @property orderId - The order in the route
 * @property data - Additional marker data
 */
export interface Marker {
  type: 'client' | 'origin';
  orderId: number;
  data: MarkerData;
}

// TEMP default center to brisbane - Possible change to company HQ location?
export const brisbaneCenter = { lat: -27.4698, lng: 153.0251 };

export const presetZoom = 12;
